/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataConstraint {
  /** unique or primary key constraint on columns "calendar_event_udf_data_id" */
  CalendarEventUdfDataPkey = 'calendar_event_udf_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "calendar_event_id" */
  CalendarEventUdfDataUnique = 'calendar_event_udf_data_unique'
}

/** select columns of table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataSelectColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.calendar_event_udf_data" */
export enum ArgoCalendarEventUdfDataUpdateColumn {
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

